import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M2.743 6.193.243 8.7a.75.75 0 0 0 1.062 1.06l2.5-2.5a.75.75 0 0 0-1.062-1.067m7.088-2.047-.884-1.2.526-1.463a.744.744 0 0 0-.955-.956l-1.463.525-1.2-.882a.75.75 0 0 0-.782-.065.77.77 0 0 0-.426.678l-.016 1.543-1.285.923a.76.76 0 0 0-.31.751.74.74 0 0 0 .524.586L5 5l.416 1.44A.74.74 0 0 0 6 6.964a.76.76 0 0 0 .749-.31l.923-1.285 1.542-.016a.77.77 0 0 0 .686-.426.75.75 0 0 0-.069-.781"
    }, null, -1)
  ]));
}
const interfaceEditMagicWand = { render };
export {
  interfaceEditMagicWand as default,
  render
};
//# sourceMappingURL=interface-edit-magic-wand.svg.js.map
